import { Toast, Toaster } from '@ark-ui/react'
import { SnackbarSeverityType } from '@/AppContext'
import { Alert } from '@/UIComponents2/Alert'
import * as Constants from '@/services/Constants'
import CrossIcon from '@/CustomIcons/CrossIcon'
import { toaster } from './RootSnackbarController'

// returns one of "warning" | "success" | "danger"
const convertSeverityToLevel = (severity: SnackbarSeverityType) => {
    switch (severity) {
        case 'success':
            return 'success'
        case 'info':
            return 'success'
        case 'error':
            return 'danger'
        case 'warning':
            return 'warning'
    }
    return 'success'
}

export default function RootSnackbarRenderer() {
    return (
        // <Presence> // maybe useful for animations
        <div style={{ zIndex: 100 }}>
            <Toaster toaster={toaster}>
                {(toast) => (
                    <Toast.Root className="w-fit h-0" key={toast.id}>
                        <div
                            className="flex justify-center w-full h-0 overflow-visible"
                            style={{ marginTop: Constants.title_bar_height }}
                        >
                            <div className="h-full">
                                <Alert
                                    className="w-[90vw] md:max-w-lg w-fit"
                                    contentClassName="w-full flex items-center justify-between gap-2"
                                    variant="solid"
                                    level={convertSeverityToLevel(toast.type as any)}
                                >
                                    {toast.title}
                                    <Toast.CloseTrigger>
                                        <div className="cursor-pointer">
                                            <CrossIcon color="black" />
                                        </div>
                                    </Toast.CloseTrigger>
                                </Alert>
                            </div>
                        </div>
                    </Toast.Root>
                )}
            </Toaster>
        </div>
        // </Presence>
    )
}
